// global
import { globalAggregationModels } from '../global';

export const dateAggregationModels = [...globalAggregationModels];
